export type AuthState = {}

export default {} as AuthState
